import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import EditTicketForm from 'src/components/Forms/EditTicketForm';

const EditTicketModal = () => (
  <ModalBase
    name={MODALS.editTicket}
    size={MODALS_SIZE.medium}
    form={FORM.edit_ticket}>
    <EditTicketForm />
  </ModalBase>
);

export default EditTicketModal;
